export function normalizeProfilePhotoSource(value?: string | null): string | null {
	if (!value) return null;
	if (/^https?:\/\//i.test(value)) return value;
	if (value.startsWith("data:")) return value;
	return `data:image/jpeg;base64,${value}`;
}

export async function profilePhotoToBlob(value: string): Promise<Blob> {
	const source = normalizeProfilePhotoSource(value);
	if (!source) throw new Error("Missing profile photo.");
	const response = await fetch(source);
	if (!response.ok) throw new Error("Unable to load profile photo.");
	return response.blob();
}

export async function profilePhotoToDataUrl(value: string): Promise<string> {
	const source = normalizeProfilePhotoSource(value);
	if (!source) throw new Error("Missing profile photo.");
	if (source.startsWith("data:")) return source;

	const blob = await profilePhotoToBlob(source);
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(String(reader.result || ""));
		reader.onerror = () => reject(new Error("Unable to read profile photo."));
		reader.readAsDataURL(blob);
	});
}
